
import { useToast } from '@/hooks/use-toast';
import { RoyaltyReport } from '@/types';
import { generateQuarterlyRoyaltyReportPDF } from '@/utils/pdfGenerator';

export const usePDFGeneration = () => {
  const { toast } = useToast();

  const handleDownloadPDF = async (
    report: RoyaltyReport,
    quarterlyReports: RoyaltyReport[] | undefined,
    totalSales: number,
    totalRoyaltyAmount: number,
    totalGrossSales: number,
    totalReturns: number,
    totalPreviousRoyaltyIncome: number,
    authorName: string
  ) => {
    if (!report) {
      toast({
        title: 'Error',
        description: 'No report data available for download',
        variant: 'destructive',
      });
      return;
    }

    try {
      // Filter to only include reports for the specific quarter and year
      const filteredReports = quarterlyReports?.filter(r => 
        r.quarter === report.quarter && r.year === report.year
      ) || [report];
      
      await generateQuarterlyRoyaltyReportPDF({
        quarter: report.quarter,
        year: report.year,
        reports: filteredReports,
        totalUnitsSold: totalSales,
        totalRoyaltyAmount: totalRoyaltyAmount,
        totalGrossSales: totalGrossSales,
        totalReturns: totalReturns,
        totalNetSales: totalPreviousRoyaltyIncome,
        authorName: authorName
      });
      
      toast({
        title: 'Success',
        description: 'PDF report downloaded successfully',
      });
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast({
        title: 'Error',
        description: 'Failed to generate PDF report',
        variant: 'destructive',
      });
    }
  };

  return { handleDownloadPDF };
};
